<template>
  <div class="flex gap-3 py-2">
    <p class="title">구분</p>
    <div class="flex-1 flex flex-wrap items-center gap-3">
      <vs-checkbox  :value="options.length === selectData.length" @click.native="clickAll">전체</vs-checkbox>
      <vs-checkbox v-for="option in options" :key="option" :vs-value="option"  v-model="selectData">{{ option }}</vs-checkbox>
    </div>
  </div>
</template>

<script>
import RadioTypeCheck from "@/components/radio/RadioTypeCheck.vue";
export default {
  components: { RadioTypeCheck },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    value: Array,
  },
  data() {
    return {
      selectData: this.value,
    };
  },
  watch: {
    value: {
      handler(value) {
        this.selectData = value;
      },
    },
    selectData: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    clickAll() {
      if (this.selectData.length === this.options.length) this.selectData = [];
      else this.selectData = this.options;
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  width: 48px;
  font-size: 14px;
  font-weight: 500;
}
</style>
